// @flow
import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
// import logo from "./logo.svg";
import "./App.css";
// import SimpleHeading from "./components/SimpleHeading";
import { Home, About, ContactUs, Products } from "./pages";
import Heading from "./components/Heading";

class App extends Component {
  render() {
    return (
      <div className="App">
        {/* <SimpleHeading /> */}
        {/* <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Welcome to React</h1>
        </header> */}
        <Router>
          <div>
            {/* <Heading /> */}
            <Route exact path="/" component={Home} />
            {/* <Route exact path="/about" component={About} /> */}
            {/* <Route exact path="/contactus" component={ContactUs} /> */}
            <Route exact path="/products" component={Products} />
          </div>
        </Router>

        {/* <p className="App-intro">
          To get started, edit <code>src/App.js</code> and save to reload.
        </p> */}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js